import React from 'react'
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';


const Container = styled.div`

min-height:300px;
display:flex;
align-items:center;
flex-direction:column;
text-align:center;
`
const Title = styled.div`

padding-top:40px;
font-family: Roboto;
font-weight: 400;
font-size:18px;
color:#5F5F5F;
padding-bottom:20px;
`
const Subtitle = styled.div`

font-family: Roboto;
font-weight: 400;
font-size:18px;
color:#5F5F5F;
padding-bottom:20px;

`


const ActionFormNoActionsEmptyState = ({masterWorkflowStep}) => {

    const isCurrentUser = masterWorkflowStep.isCurrentUser || masterWorkflowStep.isProxy;
    
    return(
        <Container>
            {isCurrentUser &&
            <>
            <Title>
                You're all caught up!
            </Title>
            <Subtitle>
                There are no pending procedures to show right now.
            </Subtitle>
            </>
            }
            {!isCurrentUser &&
            <>
            <Title/>
            <Subtitle>
            This person doesn’t have any pending procedures            
            </Subtitle>
            
            </>
            }
        </Container>
    );


}


export default ActionFormNoActionsEmptyState;